import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/tipo-de-movimiento-de-empleado';

/**
 * Get Tipos De Movimientos De Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeMovimientosDeEmpleados = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo De Movimiento De Empleado
 * @params {number} id
 * @returns {Promise<object|null>};
 */
export const getTipoDeMovimientoDeEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo De Movimiento De Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeMovimientoDeEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo De Movimiento De Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeMovimientoDeEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo De Movimiento De Empleado
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteTipoDeMovimientoDeEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
